import { render, staticRenderFns } from "./MainSettingsTable.vue?vue&type=template&id=7bb33ab2&scoped=true&"
import script from "./MainSettingsTable.vue?vue&type=script&lang=js&"
export * from "./MainSettingsTable.vue?vue&type=script&lang=js&"
import style0 from "./MainSettingsTable.vue?vue&type=style&index=0&id=7bb33ab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb33ab2",
  null
  
)

export default component.exports